<template>
  <svg
    width="81"
    height="80"
    viewBox="0 0 81 80"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M61.8335 9.87406C59.0132 4.03109 53.0321 0 46.1096 0C39.8055 0 34.2827 3.34328 31.2161 8.35297C30.3993 8.14172 29.5425 8.02891 28.6596 8.02891C23.9988 8.02891 20.0727 11.1625 18.8655 15.4369C11.0211 15.6508 4.72754 22.0766 4.72754 29.9727C4.72754 38.0037 11.238 44.5142 19.2691 44.5142H58.8222C68.4596 44.5142 76.2722 36.7016 76.2722 27.0642C76.2722 18.4539 70.0357 11.3008 61.8335 9.87406Z"
      fill="url(#paint0_linear_8058_125794)"
    />
    <path
      d="M61.833 9.87396C60.368 6.83881 58.0487 4.29459 55.189 2.54834C57.7127 7.22006 59.1462 12.5672 59.1462 18.2497C59.1462 28.9532 54.0616 38.4676 46.1777 44.5143H58.822C68.4593 44.5143 76.272 36.7016 76.272 27.0643C76.2718 18.4538 70.0352 11.3007 61.833 9.87396Z"
      fill="url(#paint1_linear_8058_125794)"
    />
    <path
      d="M33.9102 31.2556V17.5084C33.9102 15.575 36.0195 14.3806 37.6773 15.3754L49.1334 22.249C50.7438 23.2151 50.7438 25.5489 49.1334 26.515L37.6773 33.3886C36.0195 34.3834 33.9102 33.189 33.9102 31.2556Z"
      fill="#DFF6FD"
    />
    <path
      d="M53.5077 67.8048V75.1218H27.4914V67.8048C27.4914 66.4578 26.3994 65.3657 25.0523 65.3657C23.7053 65.3657 22.6133 66.4578 22.6133 67.8048V77.5609C22.6133 78.9079 23.7053 79.9999 25.0523 79.9999H55.9467C57.2938 79.9999 58.3858 78.9079 58.3858 77.5609V67.8048C58.3858 66.4578 57.2938 65.3657 55.9467 65.3657C54.5997 65.3657 53.5077 66.4578 53.5077 67.8048Z"
      fill="url(#paint2_linear_8058_125794)"
    />
    <path
      d="M55.9475 65.3657C54.6004 65.3657 53.5084 66.4578 53.5084 67.8048V77.5609C53.5084 78.9079 52.4164 79.9999 51.0693 79.9999H55.9475C57.2945 79.9999 58.3865 78.9079 58.3865 77.5609V67.8048C58.3865 66.4578 57.2945 65.3657 55.9475 65.3657Z"
      fill="url(#paint3_linear_8058_125794)"
    />
    <path
      d="M47.6495 55.532L42.2245 50.107C41.272 49.1545 39.7276 49.1545 38.7751 50.107L33.3501 55.532C32.3976 56.4845 32.3976 58.0287 33.3501 58.9812C34.3026 59.9337 35.847 59.9337 36.7995 58.9812L38.0607 57.7199V67.8052C38.0607 69.1523 39.1528 70.2443 40.4998 70.2443C41.8468 70.2443 42.9389 69.1523 42.9389 67.8052V57.7199L44.2001 58.9812C45.1526 59.9337 46.6968 59.9337 47.6493 58.9812C48.602 58.0287 48.602 56.4845 47.6495 55.532Z"
      fill="url(#paint4_linear_8058_125794)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_8058_125794"
        x1="76"
        y1="29"
        x2="5"
        y2="32"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.00886368" stop-color="#1F666A" />
        <stop offset="0.42" stop-color="#3F878D" />
        <stop offset="1" stop-color="#4F979F" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_8058_125794"
        x1="36.5"
        y1="7.5"
        x2="107"
        y2="19.5"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.0652343" stop-color="#1F666A" />
        <stop offset="0.504295" stop-color="#3F878D" />
        <stop offset="0.830415" stop-color="#4F979F" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_8058_125794"
        x1="22.6133"
        y1="72.6828"
        x2="58.3858"
        y2="72.6828"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#1F666A" />
        <stop offset="0.42" stop-color="#3F878D" />
        <stop offset="1" stop-color="#4F979F" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_8058_125794"
        x1="51.0693"
        y1="72.6828"
        x2="58.3865"
        y2="72.6828"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#1F666A" />
        <stop offset="0.42" stop-color="#3F878D" />
        <stop offset="1" stop-color="#4F979F" />
      </linearGradient>
      <linearGradient
        id="paint4_linear_8058_125794"
        x1="32.6357"
        y1="59.8184"
        x2="48.3638"
        y2="59.8184"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#1F666A" />
        <stop offset="0.42" stop-color="#3F878D" />
        <stop offset="1" stop-color="#4F979F" />
      </linearGradient>
    </defs>
  </svg>
</template>
